<template>
    <div class="tree-select report" :class="{active: selectedItem.id ==item.id}" @click="$emit('selectItem')">
          <div class="icon doc">
            <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M13.6922 5.20234L9.31719 0.827344C9.2591 0.769322 9.19015 0.723314 9.11428 0.691946C9.03841 0.660579 8.9571 0.644467 8.875 0.644531H1.375C1.04348 0.644531 0.725537 0.776227 0.491116 1.01065C0.256696 1.24507 0.125 1.56301 0.125 1.89453V15.6445C0.125 15.9761 0.256696 16.294 0.491116 16.5284C0.725537 16.7628 1.04348 16.8945 1.375 16.8945H12.625C12.9565 16.8945 13.2745 16.7628 13.5089 16.5284C13.7433 16.294 13.875 15.9761 13.875 15.6445V5.64453C13.8751 5.56243 13.859 5.48112 13.8276 5.40525C13.7962 5.32938 13.7502 5.26043 13.6922 5.20234ZM9.5 2.77813L11.7414 5.01953H9.5V2.77813ZM12.625 15.6445H1.375V1.89453H8.25V5.64453C8.25 5.81029 8.31585 5.96926 8.43306 6.08647C8.55027 6.20368 8.70924 6.26953 8.875 6.26953H12.625V15.6445ZM10.125 9.39453C10.125 9.56029 10.0592 9.71926 9.94194 9.83647C9.82473 9.95368 9.66576 10.0195 9.5 10.0195H4.5C4.33424 10.0195 4.17527 9.95368 4.05806 9.83647C3.94085 9.71926 3.875 9.56029 3.875 9.39453C3.875 9.22877 3.94085 9.0698 4.05806 8.95259C4.17527 8.83538 4.33424 8.76953 4.5 8.76953H9.5C9.66576 8.76953 9.82473 8.83538 9.94194 8.95259C10.0592 9.0698 10.125 9.22877 10.125 9.39453ZM10.125 11.8945C10.125 12.0603 10.0592 12.2193 9.94194 12.3365C9.82473 12.4537 9.66576 12.5195 9.5 12.5195H4.5C4.33424 12.5195 4.17527 12.4537 4.05806 12.3365C3.94085 12.2193 3.875 12.0603 3.875 11.8945C3.875 11.7288 3.94085 11.5698 4.05806 11.4526C4.17527 11.3354 4.33424 11.2695 4.5 11.2695H9.5C9.66576 11.2695 9.82473 11.3354 9.94194 11.4526C10.0592 11.5698 10.125 11.7288 10.125 11.8945Z" fill="#333333"/>
            </svg>

          </div>
          <div class="label">
              <span >
                    {{item.name}}
              </span>
              <!-- <input 
                  v-else 
                  type="text" 
                  v-model="item.name"
                  :placeholder="toLocal('generic.enter_name')"  
                  @mouseover="$emit('dragDisable', true)"
                  @mouseleave="$emit('dragDisable', false)"
                  v-click-outside-2="clickAwayInput"
              > -->
          </div>
          <div class="icon" :class="{opened: optionsOpen}" @click.stop="optionsOpen = true" v-click-outside="closeOptions">
            <!-- <svg class="select-icon" :style="{'z-index': optionsOpen ? '3' : ''}" xmlns="http://www.w3.org/2000/svg" width="25.667" height="6.706" viewBox="0 0 25.667 6.706">              <g id="Group_9979" data-name="Group 9979" transform="translate(498.599 -710.5) rotate(90)">                  <circle id="Ellipse_572" data-name="Ellipse 572" cx="3.353" cy="3.353" r="3.353" transform="translate(710.5 498.599) rotate(-90)" fill="#28345c"/>                  <circle id="Ellipse_573" data-name="Ellipse 573" cx="3.353" cy="3.353" r="3.353" transform="translate(710.5 489.118) rotate(-90)" fill="#28345c"/>                  <circle id="Ellipse_574" data-name="Ellipse 574" cx="3.353" cy="3.353" r="3.353" transform="translate(710.5 479.638) rotate(-90)" fill="#28345c"/>              </g>              </svg> -->
            <svg  class="select-icon" :style="{'z-index': optionsOpen ? '3' : ''}"  width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.1591 5.39931C18.6126 5.39931 19.7909 4.22124 19.7909 2.76802C19.7909 1.31479 18.6126 0.136719 17.1591 0.136719C15.7056 0.136719 14.5273 1.31479 14.5273 2.76802C14.5273 4.22124 15.7056 5.39931 17.1591 5.39931Z" fill="#92969D"/>
                <path d="M9.89544 5.39931C11.3489 5.39931 12.5272 4.22124 12.5272 2.76802C12.5272 1.31479 11.3489 0.136719 9.89544 0.136719C8.44196 0.136719 7.26367 1.31479 7.26367 2.76802C7.26367 4.22124 8.44196 5.39931 9.89544 5.39931Z" fill="#92969D"/>
                <path d="M2.63177 5.39931C4.08526 5.39931 5.26354 4.22124 5.26354 2.76802C5.26354 1.31479 4.08526 0.136719 2.63177 0.136719C1.17828 0.136719 0 1.31479 0 2.76802C0 4.22124 1.17828 5.39931 2.63177 5.39931Z" fill="#92969D"/>
            </svg>
            <div class="action-container" v-if="optionsOpen" >
                      <div class="header">
  
                      </div>
                      <div class="option" @click="$emit('duplicateItem', item)">
                          <div class="option-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.87" height="15.871" viewBox="0 0 15.87 15.871">                              <g id="Group_11113" data-name="Group 11113" transform="translate(0.5 0.5)">                                  <rect id="Rectangle_187" data-name="Rectangle 187" width="9.914" height="9.914" rx="2.835" transform="translate(4.957 4.957)" fill="none" stroke="#28345c" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>                                  <rect id="Rectangle_188" data-name="Rectangle 188" width="9.914" height="9.914" rx="2.835" fill="none" stroke="#28345c" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>                                  <line id="Line_44" data-name="Line 44" x1="2.273" y2="2.273" transform="translate(7.484 7.5)" fill="none" stroke="#28345c" stroke-linecap="round" stroke-miterlimit="10" stroke-width="0.5"/>                                  <line id="Line_45" data-name="Line 45" x1="4.188" y2="4.188" transform="translate(5.349 5.365)" fill="none" stroke="#28345c" stroke-linecap="round" stroke-miterlimit="10" stroke-width="0.5"/>                                  <line id="Line_46" data-name="Line 46" x1="2.273" y2="2.273" transform="translate(5.138 5.154)" fill="none" stroke="#28345c" stroke-linecap="round" stroke-miterlimit="10" stroke-width="0.5"/>                              </g>                              </svg>
                          </div>
                          <span class="option-label">
                              {{toLocal('generic.create_copy')}}
                          </span>
                      </div>
                      <div class="option" @click="deleteItem">
                          <div class="option-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="11.694" height="14.872" viewBox="0 0 11.694 14.872">                                  <g id="Group_10004" data-name="Group 10004" transform="translate(0 0)">                                      <g id="Group_291" data-name="Group 291" transform="translate(0 0)">                                      <path id="Rectangle_184" data-name="Rectangle 184" d="M6927.982,1771.573h9.547v8.808a3.123,3.123,0,0,1-3.117,3.12H6931.1a3.124,3.124,0,0,1-3.121-3.12Zm8.846.7h-8.144v8.106a2.421,2.421,0,0,0,2.419,2.418h3.308a2.422,2.422,0,0,0,2.417-2.418Z" transform="translate(-6926.94 -1768.63)" fill="#28345c"/>                                      <path id="Path_550" data-name="Path 550" d="M6933.777,1764.2l.084,0a1.224,1.224,0,0,1-.155,2.443h-9.176a1.222,1.222,0,0,1,0-2.444h9.178Zm0,1.746a.522.522,0,0,0,.036-1.042.463.463,0,0,0-.071,0h-9.211a.52.52,0,1,0,0,1.04h9.247Z" transform="translate(-6923.308 -1763.003)" fill="#28345c"/>                                      <path id="Path_551" data-name="Path 551" d="M6942.827,1761.029h-4.29l-.088-.22a1.225,1.225,0,0,1,1.13-1.682h2.2a1.226,1.226,0,0,1,1.136,1.681Zm-3.763-.7h3.235a.522.522,0,0,0-.521-.5h-2.2A.522.522,0,0,0,6939.064,1760.327Z" transform="translate(-6934.868 -1759.126)" fill="#28345c"/>                                      <g id="Group_290" data-name="Group 290" transform="translate(3.316 4.772)">                                          <path id="Line_35" data-name="Line 35" d="M-.149,7.218A.351.351,0,0,1-.5,6.867V-.149A.351.351,0,0,1-.149-.5.351.351,0,0,1,.2-.149V6.867A.351.351,0,0,1-.149,7.218Z" transform="translate(0.5 0.5)" fill="#28345c"/>                                          <path id="Line_36" data-name="Line 36" d="M-.149,7.218A.351.351,0,0,1-.5,6.867V-.149A.351.351,0,0,1-.149-.5.351.351,0,0,1,.2-.149V6.867A.351.351,0,0,1-.149,7.218Z" transform="translate(2.647 0.5)" fill="#28345c"/>                                          <path id="Line_37" data-name="Line 37" d="M-.149,7.218A.351.351,0,0,1-.5,6.867V-.149A.351.351,0,0,1-.149-.5.351.351,0,0,1,.2-.149V6.867A.351.351,0,0,1-.149,7.218Z" transform="translate(4.795 0.5)" fill="#28345c"/>                                      </g>                                      </g>                                  </g>                              </svg>
                          </div>
                          <span class="option-label">
                              {{toLocal('generic.delete')}}
                          </span>
                      </div>
                  </div>
          </div>
         
      </div>
  </template>
  
  <script>
  import axios from 'axios';
  import _ from 'lodash';
  export default {
      props:{
          item:{
              type:Object,
              required:true
          },
          selectedItem:{
              type:Object,
          }
      },
      data(){
          return{
              optionsOpen: false,
          }
      },
      watch:{
          item:{
              deep:true,
              handler(newVal,oldVal){
                  // if(JSON.stringify(newVal) !== JSON.stringify(oldVal)){
                //   this.debounceSave(this);
                //   let folder_id = this.$store.state.emailForming.selectedFolder;
                //   let folder_index = this.$store.state.emailForming.emailFolders.findIndex(el => el.id == folder_id);
                //   let folder = this.$store.state.emailForming.emailFolders[folder_index];
                //   let report_index = folder.reportList.findIndex(el => el.id == this.report.id);
                //   this.$set(folder.reportList, report_index, newVal);
              }
          }
      },
      methods:{
          closeOptions() {
              this.optionsOpen = false;
          },
          deleteItem(){
     
              this.$emit('deleteItem');
          },
          saveItem(){
              let id = this.item.id;
              let item = this.unsetData(this.item);
              item = {
                  id: item.id,
                  name: item.name
              }
              axios.put(
                  `${this.$store.state.api_link}/email-templates/${id}?editName=true`,
                  {
                      item:item,
                  },
                  this.$store.getters.axiosConfig()
              ).then((response) => {
                  
              })
          },
          debounceSave: _.debounce((self)=>{
            //   self.saveItem();
          }, 1000),
          unsetData(item){
              let temp = this._.cloneDeep(item);
              if(temp.data){
                  if(temp.data.reportData && temp.data.reportData.length> 0){
                      temp.data.reportData.forEach((item,index)=>{
    
                          if(item.secondarySelect){
                               item.secondarySelect=[];
                          }
                      });
                  }
              }
              return temp;
          },
          setItemName(e, item){
              if(e.target.value != ''){
                  item.name = e.target.value; 
                  this.$set(item, 'editingTitle', false);
              }
              else return;
          },
           startTitleEdit(e, item){
              if(item.editingTitle) return;
              this.$set(item, 'editingTitle', true);
              let input = e.target.parentNode.children[1];
              setTimeout(()=>{
                  if(input)
                      input.focus();
              },10);
          },
          clickAwayInput(){
              this.$set(this.item, 'editingTitle', false);
            //   let folder_id = this.$store.state.emailForming.selectedFolder;
            //   let folder_index = this.$store.state.emailForming.emailFolders.findIndex(el => el.id == folder_id);
            //   let item_index = this.$store.state.emailForming.emailFolders[folder_index].reportList.findIndex(el=>el.id == this.report.id);
            //   if(item_index!= -1){
            //       this.$set(this.$store.state.emailForming.emailFolders[folder_index].reportList[item_index], 'editingTitle', false);
            //       this.$set(this.$store.state.emailForming.emailFolders[folder_index].reportList[item_index], 'name', this.report.name); 
            //   }
          },
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .tree-select{
      position: relative;
      display: flex;
      align-items: center;
      background: white;
      border-radius: 0.5rem;
      &.report{
          
          padding: 0.5rem;
          height: 1.75rem;
          width: 100%;
          &.active{
              .doc{
                  svg{
                      path{
                          fill: white
                      }
                  }
              }
              .icon{
                    &:hover{
                        .select-icon{
                            path{
                                fill: white
                            }
                        }
                    }
                    &.opened{
                        .select-icon{
                            path{
                                fill: #333;
                            }
                        }
                    }
              }
          }
      }
      .label{
          width: 100%;
          margin-left: 0.5rem;
          color: var(--primary-color);
          cursor: pointer;
           input{
              width: 100%;
              height: 100%;
              background: none;
              border:none;
              font-size: clamp(16px, 1.2vw, 20px);
              border-bottom: 1px solid var(--primary-color-opacity-50);
              &:focus{
                  outline: none;
              }
          }
          span{
              display: block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 10px;
              min-width: 100%;
          }
          &.selected{
              font-weight: 700;
          }
      }
      .icon{
          display: flex;
          padding: 0 0.25rem;
          align-items: center;
          height: 1.5rem;
          width: 2rem;
          position: relative;
          cursor: pointer;
          svg{
              position: relative;
              path, circle{
                  transition: fill 0.3s ease;
                  fill: #92969D;
              }
              rect, line{
                  stroke: #92969D;
              }
          }
          .select-icon{
              path, circle{
                  fill: #92969D;
              }
          }
          &:hover{
              .select-icon{
                  path, circle{
                      fill: #333;
                  }
              }
          }
          &.doc{
              svg{
                  path{
                    //   stroke: var(--primary-color);
                      fill: #333333;
                  }
              }
          }
          
      }
      &.active{
        background-color: #333;
        color: white;
        .label{
            color: white;
        }
        &.doc{
            svg{
                path{
                    fill: white;
                }
            }
        }
      }
  }
  .action-container{
      position: absolute;
      right: -0.5rem;
      top: 0rem;
      border: 1px solid #333;
      background: white;
      border-radius: 0.5rem;
      padding: 0.5rem;
      z-index: 2;
      .header{
          height: 1rem;
          width: 100%;
      }
      .option{
          display: flex;
          align-items: center;
          color: #333;
          margin: 0.25rem 0;
          .option-icon{
              display: flex;
              justify-content: center;
              width: 1rem;
              margin-right: 0.25rem;
              min-height: 16px;
              height: 1rem;
          }
          .option-label{
              width: 4.5rem;
              white-space: nowrap;
              font-size: clamp(14px, 2vw, 16px);
          }
          &:hover{
              .option-label{
                  font-weight: 700;
                  
              }
          }
          svg{
              path{
                  fill: #333;
              }
          }
      }
  }
  .option-icon{
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      svg{
          height: 100%;
          width: 0.75rem;
      }
  }
  .report-count{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: -2.5rem;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 2rem;
      height: 70%;
      span{
          position: absolute;
          font-weight: 700;
          color: var(--primary-color);
      }
      svg{
          path{
              stroke: var(--primary-color);
          }
      }
  }
  .expand-enter-active,
  .expand-leave-active {
    transition: all 0.5s ease;
    min-width: 2rem;
     min-height: 2rem;
  }
  .expand-enter-from,
  .expand-leave-to {
    opacity: 0;
     min-width: 0;
      min-height: 0;
  }
  
  
  </style>